import client from '../httpClient';

const librarydirUpdateApi = (params) => {
  return client.put('/library-directories/', JSON.stringify(params), { isShowMessage: true, isShowLoading: false });
};

export default librarydirUpdateApi;
